import { connectModal } from "redux-modal";
import BMXCardModal from "../../../../Components/Modals/BMXCardModal/BMXCardModal";
import "./BMXStaticDatePickerModal.scss";
import BMXStaticDatePicker from "../../../../Components/BMXStaticDatePicker/BMXStaticDatePicker";

const BMXStaticDatePickerModal = (props) => {
    const { handleHide, show, clientX,clientY } = props;

    return (
        <BMXCardModal
            className="BMXStaticDatePickerModal"
            left={clientX}
            top={clientY}
            width="max-content"
            height="max-content"        
            open={show}
            onClose={handleHide}
            onOutside={true}
            backgroundDisable={true}
        >
            <BMXStaticDatePicker {...props} />
        </BMXCardModal>
    );
};

export default connectModal({ name: "BMXStaticDatePickerModal" })(BMXStaticDatePickerModal);